"use client";
import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { label: "About", href: "/about" },
    { label: "Specialism", href: "/specialisms" },
    { label: "Sector", href: "/sectors" },
    { label: "Impact", href: "/impact" },
    { label: "Contact Us", href: "/contact-us" },
  ];

  return (
    <nav className="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex space-x-0.5 items-center group">
          <div className="border-standard hover:border-2 hover:border-bordercolour rounded-xl transition-all px-3 py-1.5">
            <Image 
              src="/logo.png" 
              alt="Luminar Consult Logo" 
              width={44} 
              height={44}
              className="object-contain"
            />
          </div>
          <div className="border-standard border-standard-hover px-4 py-1.5 text-text-primary text-lg">
            Luminar Consult
          </div>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-3">
          {navLinks.map((link, i) => (
            <Link key={i} href={link.href} className="btn">
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden text-text-primary hover:opacity-70 transition-opacity"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {isMenuOpen && (
        <div className="lg:hidden bg-bg-primary/95 backdrop-blur-lg border-t border-standard">
          <div className="flex flex-col space-y-2 p-4">
            {navLinks.map((link, i) => (
              <Link
                key={i}
                href={link.href}
                className="btn text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}